interface CustomTickProps {
  x?: number;
  y?: number;
  payload?: {
    value: string | number;
  };
  index?: number;
}

/**
 * Factory function to create a custom tick component with rotation state
 * @param shouldRotate - Whether to rotate labels at -30 degrees (true) or render horizontally (false)
 * @returns A tick component function for Recharts
 */
export const createCustomTick = (shouldRotate: boolean = true) => {
  return (props: CustomTickProps) => {
    const { x = 0, y = 0, payload } = props;

    if (!shouldRotate) {
      // Horizontal rendering: text centered on tick point
      return (
        <g transform={`translate(${x},${y})`}>
          {/* Vertical tick line */}
          <line x1={0} y1={-22} x2={0} y2={-18} stroke="#d1d5db" strokeWidth={1} />
          {/* Text label - centered horizontally on tick point */}
          <text x={0} y={0} dy={-5} textAnchor="middle" fill="#6B7280" fontSize="12">
            {payload?.value}
          </text>
        </g>
      );
    }

    // Rotated rendering: text rotated at -30 degrees
    const rotationAngle = -30;
    return (
      <g transform={`translate(${x},${y})`}>
        {/* Vertical tick line */}
        <line x1={0} y1={-22} x2={0} y2={-18} stroke="#d1d5db" strokeWidth={1} />
        {/* Text label */}
        <text
          x={0}
          y={0}
          dy={-5}
          dx={5}
          textAnchor="end"
          fill="#6B7280"
          fontSize="12"
          transform={`rotate(${rotationAngle})`}
        >
          {payload?.value}
        </text>
      </g>
    );
  };
};

// Default export for backwards compatibility (always rotated)
export const CustomTick = createCustomTick(true);
